// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsCut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 8a2 2 0 1 0-1-.268l.033.02C6.32 7.91 6.649 8 7 8zm0-6a4 4 0 0 1 2 7.464l13.454 7.768a2 2 0 0 1-2.732.732l-8.326-4.807-2.395 1.383a4 4 0 1 1-3.93-.04l4.325-2.498-4.33-2.5A4 4 0 0 1 7 2zm12.722 4.04a2 2 0 0 1 2.732.732l-7.566 4.369-2-1.155zM7 20.004a2 2 0 1 0-.963-3.753l-.037.02a2 2 0 0 0 1 3.733z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsCut;
